import React, { FC } from 'react';

import CloseIcon from '@mui/icons-material/Close';
import FlagOutlinedIcon from '@mui/icons-material/FlagOutlined';

import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';

interface PreviewHeaderProps {
  onClose: () => any;
  onReport: () => void;
}

const PreviewHeader: FC<PreviewHeaderProps> = ({ onClose, onReport }) => (
  <AppBar
    variant='elevation'
    color='transparent'
    position='absolute'
    sx={{ boxShadow: 'none' }}
  >
    <Toolbar sx={{ justifyContent: { xs: 'space-between', md: "flex-end" }, flexDirection: { xs: 'row-reverse', md: 'row' } }}>
      <IconButton color='info' size='large' onClick={onReport}>
        <FlagOutlinedIcon />
      </IconButton>
      <IconButton color='info' size='large' onClick={onClose}>
        <CloseIcon />
      </IconButton>
    </Toolbar>
  </AppBar>
);

export default PreviewHeader;
